export default {
  id: 'healthHistory/CURRENT_ILLNESS/v1',
  formSchema: {
    title: 'encounter:widget.healthHistory.currentIllness',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'string',
        title: 'encounter:widget.healthHistory.currentIllness',
        minLength: 1
      }
    }
  },
  uiSchema: {
    id001: { 'ui:widget': 'customCKEditorWidget' },
    'x-customClass': 'problem-description-widget'
  }
};
